import { DrawingTiltSensor } from 'src/app/pages/site-config/components/drawing-tilt-editor/drawing-tilt-sensor.interface';
import { Site } from 'src/app/shared/interfaces/site';

import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';

import { SiteDetailTiltDrawingViewerService } from './site-detail-tilt-drawing-viewer.service';
import { AccountService } from 'src/app/shared/services/account.service';

@Component({
  selector: 'app-site-detail-tilt-drawing-viewer',
  templateUrl: './site-detail-tilt-drawing-viewer.component.html',
  styleUrls: ['./site-detail-tilt-drawing-viewer.component.scss'],
})
export class SiteDetailTiltDrawingViewerComponent implements OnChanges {
  @Input() site: Site = {} as Site;
  // 19 : 6 = svgWidth : svgHeight
  // svgWidth = svgHeight * 19 / 6
  @Input() svgWidth: number = 0;
  @Input() svgHeight: number = 400;

  // 画像が選択されていない状態の背景色
  svgBgColor = 'lightgray';
  // 画像が選択されているかどうか
  isImageLoaded = false;

  // 山留センサーのマーカー半径
  markerRadius = 20;

  drawingTiltSensors: DrawingTiltSensor[] = [];

  private accountService = inject(AccountService);

  constructor(
    private drawingViewerService: SiteDetailTiltDrawingViewerService
  ) {}

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    if (this.site === null) {
      this.setDefaultBackground();
      return;
    }

    if (
      this.site.drawingTilt !== undefined &&
      this.site.drawingTilt.imageUrl !== undefined
    ) {
      this.setImageBackground(this.site.drawingTilt.imageUrl);
    } else {
      this.setDefaultBackground();
    }

    this.drawingTiltSensors =
      await this.drawingViewerService.getDrawingSensorsFromSite(this.site);
  }

  setImageBackground(imageUrl: string) {
    const img = new Image();
    img.src = imageUrl;

    img.onload = () => {
      const svg = document.getElementById('svg-tilt-viewer') as HTMLElement;

      // 画像のサイズを取得
      const imgWidth = img.width;
      const imgHeight = img.height;

      // 画像の縦横比を計算
      const aspectRatio = imgWidth / imgHeight;

      // 画像の縦横比を維持したまま、SVGの横のサイズを設定
      // 縦は固定
      this.svgWidth = this.svgHeight * aspectRatio;
      svg.style.backgroundImage = `url(${imageUrl})`;
      this.isImageLoaded = true;
    };
  }

  // SVGの背景をデフォルト設定
  setDefaultBackground() {
    // SVG背景色を設定する
    const svg = document.getElementById('svg-tilt-viewer') as HTMLElement;
    if (svg) {
      svg.style.backgroundColor = this.svgBgColor;
      svg.style.backgroundImage = 'none';
    }
    // svgWidthを初期化
    this.svgWidth = (this.svgHeight * 19) / 6;

    this.isImageLoaded = false;
  }
}
